import Excel from 'exceljs';

export const setReportMetadata = (workbook: Excel.Workbook) => {
  workbook.creator = 'EZS_FRONT';
  workbook.lastModifiedBy = 'EZS_FRONT';
  workbook.created = new Date();
  workbook.modified = new Date();
};
